import {createContext, useContext} from 'react';
import {
  CurrentProcess,
  CurrentTask,
  SuccessClaimCallbackData
} from '../../types';
import {AlertSettingsProps} from '../../../settings/alert_alarm/types';
import {ProcessActionPopupData} from '../../../processes/types';
import {GroupListProps} from '../../../../constants/types';

type TaskViewContextParams = {
  isLoading: boolean,
  setIsLoading: (value: boolean) => void,
  error: string,
  processStartedAt?: Nullable<string>,
  processId: Nullable<number>,
  setError: (error: string) => void,
  process: Nullable<CurrentProcess>,
  currentTasks: Nullable<CurrentTask[]>,
  setCurrentTasks: (tasks: Nullable<CurrentTask[]>) => void,
  taskAlertData: Nullable<AlertSettingsProps>,
  processAlertData: Nullable<AlertSettingsProps>,
  isActionProcessing: boolean,
  setIsActionProcessing: (value: boolean) => void,
  processActionsPopupData: Nullable<ProcessActionPopupData>,
  setProcessActionsPopupData: (value: Nullable<ProcessActionPopupData>) => void,
  availableProcessAssigneeGroups: Nullable<GroupListProps[]>,
  successClaimCallback: (value: SuccessClaimCallbackData) => void,
  getProcessDetails: () => Promise<void>,
  formattedTasks: any,
  setDelay: (value: number) => void,
  addCompletedTaskToArray: (task: CurrentTask) => void
}

export const TaskViewContext =
  createContext<Nullable<TaskViewContextParams>>(null);

export const useTaskView = () => {
  const context = useContext(TaskViewContext);

  if (!context) {
    throw new Error('useTaskView must be within TaskViewProvider');
  }

  return context;
};
